import React from 'react';

const ImageTooltipContent = ({ filePath, fileName }) => (
    <div style={{ textAlign: 'center' }}>
        <img
            src={filePath}
            alt={fileName}
            style={{ maxWidth: '300px', maxHeight: '300px' }} // Adjust size as needed
        />
        <p>{fileName}</p>
    </div>
);

export default ImageTooltipContent;